import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useToaster } from '~/composables/_next/useToaster';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useProductWishlistStore } from '~/composables/_next/stores/useProductWishlistStore';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
import { isProductInStock } from '~/utils/ProductAvailability';
import { gtmDiscountValue, centimesToEuros } from '~/helpers/gtm';
import { useTracking } from '@/composables/_next/useTracking';
export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistButton',
  props: {
    masterVariantSku: null,
    productId: null,
    productName: null,
    product: null,
    isInStock: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useProductWishlistSt = useProductWishlistStore(),
      productWishlist = _useProductWishlistSt.productWishlist,
      loadProductWishlist = _useProductWishlistSt.loadProductWishlist,
      addProductToWishlist = _useProductWishlistSt.addProductToWishlist,
      removeProductFromWishlist = _useProductWishlistSt.removeProductFromWishlist,
      checkProductInWishlist = _useProductWishlistSt.checkProductInWishlist;
    var _useTracking = useTracking(),
      track = _useTracking.track;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country,
      currency = _useLocalization.currency,
      locale = _useLocalization.locale;
    var _useToaster = useToaster(),
      showToast = _useToaster.show;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var isInStock = computed(function () {
      return isProductInStock(props.product);
    });
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      $trackers = _useNuxt2App.$trackers,
      $sentry = _useNuxt2App.$sentry;
    var pageUrl = (route === null || route === void 0 ? void 0 : route.fullPath) || '';
    var loading = ref(false);
    var isFavorite = computed(function () {
      return checkProductInWishlist(props.productId);
    });

    /**
     * Toggles the wishlisted status of the current product
     */
    function toggleAddToWishlist() {
      try {
        loading.value = true;
        if (isFavorite.value) {
          doActionOrLogin({
            nextRoutePath: route.path,
            previousRoutePath: route.path,
            action: handleRemoveProductFromWishlist
          });
        } else {
          doActionOrLogin({
            nextRoutePath: route.path,
            previousRoutePath: route.path,
            action: handleAddProductToWishlist
          });
        }
      } catch (error) {
        loading.value = false;
        showToast({
          title: i18n.t('wishlist-button.toast.error')
        }, 2000);
      }
    }
    /**
     * Return regular and special price for a given country from EUR price set.
     *
     * @param {any} prices - Object containing prices by currency (e.g., { EUR: { ... } })
     * @param {string} countryCode - ISO 2-letter country code (e.g., "FR")
     * @returns {{ regular: number, special: number | null }} - Price information
     */
    function getPricesByCountry(prices, countryCode) {
      var _prices$EUR, _eurPrices$priceValue, _values$find, _match$value, _match$discountedValu;
      if (_typeof(prices) !== 'object') {
        return {
          regular: 0,
          special: null
        };
      }
      var eurPrices = (_prices$EUR = prices.EUR) !== null && _prices$EUR !== void 0 ? _prices$EUR : null;
      if (_typeof(eurPrices) !== 'object') {
        return {
          regular: 0,
          special: null
        };
      }
      var values = (_eurPrices$priceValue = eurPrices === null || eurPrices === void 0 ? void 0 : eurPrices.priceValues) !== null && _eurPrices$priceValue !== void 0 ? _eurPrices$priceValue : [];
      if (!Array.isArray(values)) {
        return {
          regular: 0,
          special: null
        };
      }
      var match = (_values$find = values.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.country) === countryCode;
      })) !== null && _values$find !== void 0 ? _values$find : values.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.country) === 'Any';
      });
      if (!match) {
        return {
          regular: eurPrices === null || eurPrices === void 0 ? void 0 : eurPrices.max,
          special: null
        };
      }
      return {
        regular: (_match$value = match.value) !== null && _match$value !== void 0 ? _match$value : 0,
        special: (_match$discountedValu = match.discountedValue) !== null && _match$discountedValu !== void 0 ? _match$discountedValu : null
      };
    }
    /**
     * Build GTM tracking data for a product.
     * @param {AisHitProduct | Product} product - Product object to track.
     * @returns {object} Tracking data object for GTM (always with fallback).
     */
    function trackingData(product) {
      var _product$price$value$, _product$price, _product$price$value;
      var gtmProduct = {};
      if ((_product$price$value$ = product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$value = _product$price.value) === null || _product$price$value === void 0 ? void 0 : _product$price$value.centAmount) !== null && _product$price$value$ !== void 0 ? _product$price$value$ : false) {
        var _product$price$value$2, _product$price$value$3, _product$price$value$4, _gtmDiscountValue, _product$_name, _product$sku, _centimesToEuros, _product$_id, _product$_master;
        var regularPrice = (_product$price$value$2 = product.price.value.centAmount) !== null && _product$price$value$2 !== void 0 ? _product$price$value$2 : 0;
        var specialPrice = (_product$price$value$3 = (_product$price$value$4 = product.price.value.special) === null || _product$price$value$4 === void 0 ? void 0 : _product$price$value$4.centAmount) !== null && _product$price$value$3 !== void 0 ? _product$price$value$3 : 0;
        gtmProduct = {
          discount: (_gtmDiscountValue = gtmDiscountValue(regularPrice, specialPrice)) !== null && _gtmDiscountValue !== void 0 ? _gtmDiscountValue : 0,
          name_locale: (_product$_name = product._name) !== null && _product$_name !== void 0 ? _product$_name : '',
          sku: (_product$sku = product.sku) !== null && _product$sku !== void 0 ? _product$sku : '',
          price: (_centimesToEuros = centimesToEuros(regularPrice)) !== null && _centimesToEuros !== void 0 ? _centimesToEuros : 0,
          ct_product_id: (_product$_id = product._id) !== null && _product$_id !== void 0 ? _product$_id : '',
          currency: currency,
          is_master_in_front: (_product$_master = product._master) !== null && _product$_master !== void 0 ? _product$_master : false,
          is_in_stock: isInStock.value
        };
      } else {
        var _getPricesByCountry, _product$variants$0$p, _product$variants, _product$variants$, _gtmDiscountValue2, _product$name, _product$masterVarian, _centimesToEuros2, _product$objectID;
        var prices = (_getPricesByCountry = getPricesByCountry((_product$variants$0$p = product === null || product === void 0 ? void 0 : (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : (_product$variants$ = _product$variants[0]) === null || _product$variants$ === void 0 ? void 0 : _product$variants$.prices) !== null && _product$variants$0$p !== void 0 ? _product$variants$0$p : [], country)) !== null && _getPricesByCountry !== void 0 ? _getPricesByCountry : {
          regular: 0,
          special: 0
        };
        gtmProduct = {
          discount: (_gtmDiscountValue2 = gtmDiscountValue(prices.regular, prices.special)) !== null && _gtmDiscountValue2 !== void 0 ? _gtmDiscountValue2 : 0,
          name_locale: (_product$name = product.name) !== null && _product$name !== void 0 ? _product$name : '',
          sku: (_product$masterVarian = product.masterVariantID) !== null && _product$masterVarian !== void 0 ? _product$masterVarian : '',
          price: (_centimesToEuros2 = centimesToEuros(prices.regular)) !== null && _centimesToEuros2 !== void 0 ? _centimesToEuros2 : 0,
          ct_product_id: (_product$objectID = product.objectID) !== null && _product$objectID !== void 0 ? _product$objectID : '',
          currency: currency,
          is_master_in_front: true,
          is_in_stock: props.isInStock
        };
      }
      return {
        products: [gtmProduct]
      };
    }

    /**
     * Removes the product from wishlist.
     */
    function handleRemoveProductFromWishlist() {
      return _handleRemoveProductFromWishlist.apply(this, arguments);
    }
    /**
     * Adds the product to wishlist.
     */
    function _handleRemoveProductFromWishlist() {
      _handleRemoveProductFromWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _productWishlist$valu, _productWishlist$valu2;
        var wishlistProduct, _wishlistProduct$vari;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              wishlistProduct = (_productWishlist$valu = productWishlist.value) === null || _productWishlist$valu === void 0 ? void 0 : (_productWishlist$valu2 = _productWishlist$valu.lineItems) === null || _productWishlist$valu2 === void 0 ? void 0 : _productWishlist$valu2.find(function (item) {
                return (item === null || item === void 0 ? void 0 : item.productId) === props.productId;
              });
              if (!wishlistProduct) {
                _context.next = 20;
                break;
              }
              _context.prev = 2;
              loading.value = true;
              _context.next = 6;
              return removeProductFromWishlist(wishlistProduct.id);
            case 6:
              track('remove_from_wishlist', _objectSpread({}, trackingData(props.product)));
              $trackers.gtm.pushEvent('remove_from_wishlist', {
                event_category: 'ecommerce',
                event_label: 'remove_from_wishlist',
                event_name: 'remove_from_wishlist',
                product_name: (props === null || props === void 0 ? void 0 : props.productName) || '',
                product_id: (wishlistProduct === null || wishlistProduct === void 0 ? void 0 : (_wishlistProduct$vari = wishlistProduct.variant) === null || _wishlistProduct$vari === void 0 ? void 0 : _wishlistProduct$vari.sku) || '',
                page_url: pageUrl
              });
              showToast({
                title: i18n.t('wishlist-button.toast.removed'),
                iconName: 'checkmark'
              }, 2000);
              _context.next = 17;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('product', {
                id: props.productId,
                name: props.productName
              });
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context.t0);
              showToast({
                title: i18n.t('wishlist-button.toast.error')
              }, 2000);
            case 17:
              _context.prev = 17;
              loading.value = false;
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 11, 17, 20]]);
      }));
      return _handleRemoveProductFromWishlist.apply(this, arguments);
    }
    function handleAddProductToWishlist() {
      return _handleAddProductToWishlist.apply(this, arguments);
    }
    function _handleAddProductToWishlist() {
      _handleAddProductToWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (props.masterVariantSku) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              if (!checkProductInWishlist(props.productId)) {
                _context2.next = 5;
                break;
              }
              loading.value = false;
              return _context2.abrupt("return");
            case 5:
              _context2.prev = 5;
              loading.value = true;
              _context2.next = 9;
              return addProductToWishlist(props.productId);
            case 9:
              track('add_to_wishlist', _objectSpread({}, trackingData(props.product)));
              $trackers.gtm.pushEvent('add_to_wishlist', {
                event_category: 'ecommerce',
                event_label: 'add_to_wishlist',
                event_name: 'add_to_wishlist',
                product_name: (props === null || props === void 0 ? void 0 : props.productName) || '',
                product_id: (props === null || props === void 0 ? void 0 : props.masterVariantSku) || '',
                page_url: pageUrl
              });
              showToast({
                title: i18n.t('wishlist-button.toast.added'),
                iconColor: 'var(--c-secondary-purple-900)',
                iconName: 'heart_filled'
              }, 2000);
              _context2.next = 20;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](5);
              console.error(_context2.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('product', {
                id: props.productId,
                name: props.productName
              });
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context2.t0);
              showToast({
                title: i18n.t('wishlist-button.toast.error')
              }, 2000);
            case 20:
              _context2.prev = 20;
              loading.value = false;
              return _context2.finish(20);
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[5, 14, 20, 23]]);
      }));
      return _handleAddProductToWishlist.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      productWishlist: productWishlist,
      loadProductWishlist: loadProductWishlist,
      addProductToWishlist: addProductToWishlist,
      removeProductFromWishlist: removeProductFromWishlist,
      checkProductInWishlist: checkProductInWishlist,
      track: track,
      client: client,
      country: country,
      currency: currency,
      locale: locale,
      showToast: showToast,
      doActionOrLogin: doActionOrLogin,
      isInStock: isInStock,
      route: route,
      i18n: i18n,
      $trackers: $trackers,
      $sentry: $sentry,
      pageUrl: pageUrl,
      loading: loading,
      isFavorite: isFavorite,
      toggleAddToWishlist: toggleAddToWishlist,
      getPricesByCountry: getPricesByCountry,
      trackingData: trackingData,
      handleRemoveProductFromWishlist: handleRemoveProductFromWishlist,
      handleAddProductToWishlist: handleAddProductToWishlist,
      AzButton: AzButton,
      AzIcon: AzIcon
    };
  }
});